import { Alert, Button, Box, Typography, Stack } from '@mui/material';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { useAuth } from 'contexts/AuthContext';
import { useNavigate } from 'react-router';
import { getRoleLabel } from 'utils/statusHelpers';

const ImpersonationBanner = () => {
  const { user, impersonationState, stopImpersonation, isImpersonating } = useAuth();
  const navigate = useNavigate();

  if (!isImpersonating || !impersonationState) {
    return null;
  }

  const handleStopImpersonation = async () => {
    try {
      await stopImpersonation();
      // Redirect to admin users page after stopping impersonation
      navigate('/admin/users');
    } catch (error) {
      console.error('Failed to stop impersonation:', error);
    }
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        backgroundColor: '#ff9800',
        color: 'white',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}
    >
      <Alert
        severity="warning"
        icon={<UserOutlined style={{ fontSize: 16 }} />}
        sx={{
          backgroundColor: '#ff9800',
          color: 'white',
          '& .MuiAlert-icon': {
            color: 'white'
          },
          '& .MuiAlert-message': {
            width: '100%'
          },
          borderRadius: 0,
          py: 0.5,
          minHeight: 'auto'
        }}
        action={
          <Button
            color="inherit"
            size="small"
            variant="outlined"
            startIcon={<LogoutOutlined style={{ fontSize: 14 }} />}
            onClick={handleStopImpersonation}
            sx={{
              borderColor: 'white',
              color: 'white',
              fontSize: '0.8125rem',
              py: 0.5,
              px: 1.5,
              '&:hover': {
                borderColor: 'white',
                backgroundColor: 'rgba(255, 255, 255, 0.1)'
              }
            }}
          >
            Exit Impersonation
          </Button>
        }
      >
        <Stack
          direction="row"
          spacing={1.5}
          sx={{
            alignItems: 'center'
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontWeight: '600',
              fontSize: '0.875rem'
            }}
          >
            Viewing as: {user?.first_name} {user?.last_name}
          </Typography>
          <Typography variant="caption" sx={{ opacity: 0.9, fontSize: '0.8125rem' }}>
            ({getRoleLabel(user?.role)})
          </Typography>
          <Typography variant="caption" sx={{ opacity: 0.85, ml: 1, fontSize: '0.8125rem' }}>
            • Admin: {impersonationState.adminInfo?.first_name} {impersonationState.adminInfo?.last_name}
          </Typography>
        </Stack>
      </Alert>
    </Box>
  );
};

export default ImpersonationBanner;
